export default "__VITE_ASSET__BcftOvqV__"